import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import drEasyApi from "../Api/Customapi";

// ── Keys ──────────────────────────────────────────────────────────────────────
export const vacationKeys = {
  all: ["vacations"],
  list: (filters) => ["vacations", "list", filters],
  check: (doctorId) => ["vacations", "check", doctorId],
};

// ── GET: list of all doctors' vacations ──────────────────────────────────────
export const useGetDoctorsVacations = (filters = {}) =>
  useQuery({
    queryKey: vacationKeys.list(filters),
    queryFn: async () => {
      const { data } = await drEasyApi.get("/api/Vacation/GetMyDoctorsVacations", {
        params: {
          ...(filters.doctorId && { DoctorId: filters.doctorId }),
          ...(filters.status !== undefined && filters.status !== null && { Status: filters.status }),
          ...(filters.fromDate && { FromDate: filters.fromDate }),
          ...(filters.toDate && { ToDate: filters.toDate }),
          ...(filters.searchDoctorName && { SearchDoctorName: filters.searchDoctorName }),
          ...(filters.isConsultant !== undefined && filters.isConsultant !== null && { IsConsultant: filters.isConsultant }),
          PageNumber: filters.pageNumber || 1,
          PageSize: filters.pageSize || 10,
        },
      });
      return data;
    },
    keepPreviousData: true,
  });

// ── GET: check if a specific doctor is on vacation ───────────────────────────
export const useCheckDoctorVacation = (doctorId) =>
  useQuery({
    queryKey: vacationKeys.check(doctorId),
    queryFn: async () => {
      const { data } = await drEasyApi.get("/api/Vacation/CheckDoctorVacations", {
        params: { DoctorId: doctorId },
      });
      return data;
    },
    enabled: !!doctorId,
  });

// ── POST: respond to a regular doctor vacation ────────────────────────────────
export const useRespondToVacation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) =>
      drEasyApi.post("/api/Vacation/RespondToVacation", payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: vacationKeys.all }),
  });
};

// ── POST: respond to a specialist/consultant vacation ────────────────────────
export const useRespondToSpecialistVacation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) =>
      drEasyApi.post("/api/Vacation/RespondToSpecialistVacation", payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: vacationKeys.all }),
  });
};